const UTM_STORAGE_KEY = "utm_params";

export const getOrCreateSessionId = () => {
  let sessionId = sessionStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random()}`;
    sessionStorage.setItem("sessionId", sessionId);
  }
  return sessionId;
};


export const extractUtmParams = (search) => {
  const params = new URLSearchParams(search);
  const fresh = {
    source: params.get("utm_source") || null,
    medium: params.get("utm_medium") || null,
    campaign: params.get("utm_campaign") || null,
    term: params.get("utm_term") || null,
    content: params.get("utm_content") || null,
  };

  const hasFreshUtm = Object.values(fresh).some(Boolean);

  if (hasFreshUtm) {
    try {
      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(fresh));
    } catch {
      // sessionStorage indisponible (mode privé strict, quota...) : on ignore
    }
    return fresh;
  }

  try {
    const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch {
    // stored corrompu ou sessionStorage indisponible : on ignore
  }

  return {
    source: null,
    medium: null,
    campaign: null,
    term: null,
    content: null,
  };
};

export const guessSource = (referrer) => {
  if (!referrer) return "direct";
  try {
    const host = new URL(referrer).hostname;
    if (host.includes("google")) return "google";
    if (host.includes("facebook")) return "facebook";
    if (host.includes(window.location.hostname)) return "interne";
    return host;
  } catch {
    return "direct";
  }
};